<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select [disabled]="SchoolLoading == true || EventLoading == true || ScanLoading == true" class="form-control" name="SchoolSelector" style="font-size:smaller;"
					[(ngModel)]="scanData.SchoolID"
					(ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
				</select> -->

				<caass-schoolselector [ShowAll]="false" [Disabled]="EventLoading == true || ScanLoading == true"> </caass-schoolselector>
			</div>
		</div>

		<div class="selector-item">
			<div>
				<label>Event</label>
			</div>
			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					[disabled]="EventLoading == true || ScanLoading == true"
					class="form-control"
					name="EventSelector"
					style="font-size: smaller"
					[(ngModel)]="scanData.EventID"
					(ngModelChange)="onEventChange($event)"
				>
					<option *ngFor="let r of lstEvent" [ngValue]="r.EventID">{{ r.EventDescShort }} - {{ FormatDate(r.EventDT) }}</option>
				</select>
			</div>
		</div>

		<div class="selector-item">
			<label class="leftMargin">Start Date:</label>
			<p-calendar
				[disabled]="EventLoading == true || ScanLoading == true"
				class="leftMargin"
				(ngModelChange)="onStartDateChange($event)"
				[(ngModel)]="scanData.startDate"
				showIcon="true"
				showButtonBar="true"
				name="StartDate"
			></p-calendar>
			<label class="leftMargin">End Date:</label>
			<p-calendar
				[disabled]="EventLoading == true || ScanLoading == true"
				class="leftMargin"
				(ngModelChange)="onEndDateChange($event)"
				[(ngModel)]="scanData.endDate"
				showIcon="true"
				showButtonBar="true"
				name="EndDate"
			></p-calendar>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<!--Refresh Button-->
		<button [disabled]="EventLoading == true || ScanLoading == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button [disabled]="EventLoading == true || ScanLoading == true" class="btn btn-primary" style="margin-left: 5px" (click)="onViewDetails()">
			View Details
		</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[loading]="EventLoading == true || ScanLoading == true"
		[value]="lstEventScans"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedEventScan"
		dataKey="EventScanID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th>
					<p-columnFilter field="StudentID" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterStudentID
								[ngModel]="value"
								[options]="lstStudentID"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="PersonName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="EventScanTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterEventScanTypeDesc
								[ngModel]="value"
								[options]="lstScanResult"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Date-->
				<th></th>

				<th>
					<p-columnFilter field="ScanStation" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterScanStation
								[ngModel]="value"
								[options]="lstScanStation"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th pSortableColumn="StudentID">Student ID<p-sortIcon field="StudentID"></p-sortIcon></th>
				<th pSortableColumn="StudentName">Student Name<p-sortIcon field="StudentName"></p-sortIcon></th>
				<th pSortableColumn="ScanResult">Scan Result<p-sortIcon field="ScanResult"></p-sortIcon></th>
				<th pSortableColumn="EventScanDT">Event Scan Date/Time<p-sortIcon field="EventScanDT"></p-sortIcon></th>
				<th pSortableColumn="ScanStation">Scan Station<p-sortIcon field="ScanStation"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-eventscan>
			<tr [pSelectableRow]="eventscan" (dblclick)="onRowDblClick(eventscan)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ eventscan[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="form-group groups-TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
